import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: config.serverUrl,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const reasonApi = {
  getReasonList: (request) => {
    const { params } = request
    return instance().get(`api/ticket/v3/cms/page/reason`, { params })
  },
  postReason: (request) => {
    const { data } = request
    return instance().post(`api/ticket/v3/cms/page/reason`, data)
  },
  deleteReason: (request) => {
    const { data } = request
    return instance().delete(`api/ticket/v3/cms/page/reason`, { data })
  }
}

export default reasonApi



// WEBPACK FOOTER //
// ./src/api/reason.js